import React from "react";
import { motion } from "framer-motion";
import cancerImg from "../assets/cancer_project.png";
const Card1 = () => {
  return (
    <motion.div
      initial={"hidden"}
      whileInView={"visible"}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      class="max-w-xl bg-white rounded-lg border border-gray-200 shadow-lg bg-gray-100 dark:border-gray-700 my-8"
    >
      <a href="https://breast-cancer-predict-4649b7a38630.herokuapp.com/home" target="_blank" rel="noopener noreferrer">
        <img
          class="rounded-t-lg w-full"
          src={cancerImg}
          alt="Breast cancer project home page"
        />
      </a>
      <div class="p-5">
        <a href="https://github.com/nick3948/breast--cancer--predict" target="_blank" rel="noopener noreferrer">
        <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-black hover:text-blue-500 transition-colors duration-300 cursor-pointer">
        Breast Cancer Prediction
          </h5>
        </a>
        <p class="mb-3 font-normal text-gray-700 dark:text-black-400">
          Designed and implemented a full stack platform for breast cancer prediction, achieving 94% accuracy by ML
          algorithms and handling 100+ patient entries daily, highlighting skills in scalable backend (Django) and
          responsive frontend (HTML, CSS, JavaScript) development and attention to detail.
        </p>
        
      </div>
    </motion.div>
  );
};

export default Card1;
